import React from "react";
import { Grid, TextField, Box } from "@mui/material";
import { COVERAGE_FORM } from "@platform/rfp-core";
import { Typography } from "@platform/design-system";

import { SectionTitle } from "./styledComponents";

const { CURRENT_COMMISSION, REQUESTED_COMMISSION, SINGLE_PLAN } = COVERAGE_FORM;

const CommissionSection = ({
  handlePlanFormChange,
  handlePlanFormChangeWithValidation,
  handlePreviousFieldsValidation,
  currentPlanErrors,
  currentPlan,
  planName = SINGLE_PLAN,
  isCurrentCoverage,
}) => (
  <>
    <SectionTitle>Commission Information</SectionTitle>
    <Grid container spacing={2} px={2}>
      {isCurrentCoverage && (
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            data-testid="current-commission-label"
            fullWidth
            name={CURRENT_COMMISSION}
            error={!!currentPlanErrors[CURRENT_COMMISSION]}
            value={currentPlan[CURRENT_COMMISSION] || ""}
            onChange={(e) => {
              handlePlanFormChange(e.target, planName);
            }}
            onFocus={() => {
              if (handlePreviousFieldsValidation) {
                handlePreviousFieldsValidation(CURRENT_COMMISSION, planName);
              }
            }}
            onBlur={(e) => {
              if (handlePlanFormChangeWithValidation) {
                handlePlanFormChangeWithValidation(e.target, planName);
              }
            }}
            required
            label="Current Commission"
            autoComplete="off"
          />
          <Box>
            {!!currentPlanErrors && (
              <Typography variant="caption" color="danger">
                {currentPlanErrors[CURRENT_COMMISSION]}
              </Typography>
            )}
          </Box>
        </Grid>
      )}
      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          data-testid="required-commission-label"
          required={!isCurrentCoverage}
          fullWidth
          name={REQUESTED_COMMISSION}
          error={!!currentPlanErrors[REQUESTED_COMMISSION]}
          value={currentPlan[REQUESTED_COMMISSION] || ""}
          onChange={(e) => {
            handlePlanFormChange(e.target, planName);
          }}
          onFocus={() => {
            if (handlePreviousFieldsValidation) {
              handlePreviousFieldsValidation(REQUESTED_COMMISSION, planName);
            }
          }}
          onBlur={(e) => {
            if (handlePlanFormChangeWithValidation) {
              handlePlanFormChangeWithValidation(e.target, planName);
            }
          }}
          label="Requested Commission"
          autoComplete="off"
        />
        <Box>
          {!!currentPlanErrors && (
            <Typography variant="caption" color="danger">
              {currentPlanErrors[REQUESTED_COMMISSION]}
            </Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  </>
);

export default CommissionSection;
